import React from "react";
import { useServices } from "../../services/Services";
import { format, parse } from "date-fns";
import { Link } from "react-router-dom";
import css from "./Sidebar.module.css";

interface SidebarPDBSectionProps {
  userId: string;
  isCurrentRoute: (path: string) => boolean;
  onItemSelect: () => void;
}

const SidebarPDBSection: React.FC<SidebarPDBSectionProps> = ({
  userId,
  isCurrentRoute,
  onItemSelect,
}) => {
  const services = useServices();

  const {
    data: pdbData,
    fetchNextPage: fetchNextPDBPage,
    hasNextPage: hasNextPDBPage,
    isFetchingNextPage: isFetchingNextPDBPage,
  } = services.Report.useGetPDBReportsInfinite(userId, 10);

  const pdbReports: string[] =
    pdbData?.pages?.flatMap((page: { data: string[] }) => page.data) ?? [];

  return (
    <>
      <div className={css.sectionTitle}>
        <span className={css.sectionTitleText}>Personal Daily Briefs</span>
      </div>
      <div className={css.insightsList}>
        {pdbReports.map((dateAndId) => {
          const date = dateAndId.substring(0, 10);
          const parsedDate = parse(date, "yyyy-MM-dd", new Date());
          const path = `/report/daily/${format(parsedDate, "yyyy-MM-dd")}`;
          const title = `PDB - ${format(parsedDate, "MMM dd, yyyy")}`;
          return (
            <Link
              key={dateAndId}
              to={path}
              className={`${css.insightItem} ${isCurrentRoute(path) ? css.currentRoute : ""}`}
              onClick={onItemSelect}
            >
              <div className={css.itemContent}>
                <div className={css.itemTitle} title={title}>
                  {title}
                </div>
              </div>
              <div className={css.itemDate}>{format(parsedDate, "MMM dd")}</div>
            </Link>
          );
        })}
        {hasNextPDBPage && (
          <button
            className={css.loadMoreButton}
            onClick={() => fetchNextPDBPage()}
            disabled={isFetchingNextPDBPage}
          >
            {isFetchingNextPDBPage ? "Loading..." : "Load More"}
          </button>
        )}
      </div>
    </>
  );
};

export default SidebarPDBSection;
